import React, { FC, useEffect, useState } from "react";
import useProjectStore, { IDeviceInstance } from "common/store/ProjectStore";
import useDeviceStore from "common/store/DeviceStore";

interface IProps {
  device: IDeviceInstance;
  plotImageTransform: number;
}

const ShowDevice: FC<IProps> = (props) => {
  const { device, plotImageTransform } = props;

  const { iconPercent, zoomPercent } = useProjectStore();
  const lookupDeviceImage = useDeviceStore((state) => state.lookupDeviceImage);

  const [calculatedX, setCalculatedX] = useState<number>();
  const [calculatedY, setCalculatedY] = useState<number>();

  const [deviceIcon, setDeviceIcon] = useState<string>("");

  const iconHW = 40;

  useEffect(() => {
    setDeviceIcon(lookupDeviceImage(device.deviceID));
  }, [device.deviceID, lookupDeviceImage]);

  useEffect(() => {
    setCalculatedX(device.xPosition * plotImageTransform - iconHW / 2);
    setCalculatedY(device.yPosition * plotImageTransform - iconHW / 2);
  }, [device.xPosition, device.yPosition, plotImageTransform]);

  return (
    <>
      {calculatedX && calculatedY && (
        <img
          src={deviceIcon}
          alt="non-active network device icon"
          style={{
            position: "absolute",
            left: calculatedX,
            top: calculatedY,
            height: iconHW.toString() + "px",
            width: iconHW.toString() + "px",
            pointerEvents: "none",
            opacity: 0.5,
            filter: "grayscale(1)",
            transform: `scale(${iconPercent / 100 / (zoomPercent / 100)})`,
          }}
        />
      )}
    </>
  );
};

export default ShowDevice;
